import React, { Component } from 'react'
import PropTypes from 'prop-types'

export class BackOfficeAlert extends Component {
  static propTypes = {
    onPay: PropTypes.func,
    adjustment: PropTypes.object,
    downloadReceipt: PropTypes.func
  };

  constructor (props) {
    super(props)
    this.state = {
      showAdjustmentDetails: false,
      payment: 'SPORTELLO_CONTANTI'
    }
  }

  render () {
    const {
      total,
      payed,
      vehicle1,
      vehicle2,
      vehicle3,
      mark1,
      mark2,
      mark3
    } = this.props.adjustment
    return (
      <div
        className={'alert ' + (payed ? 'alert-success' : 'alert-warning')}
        role="alert"
      >
        {!!payed && (
          <div>
            Questo utente ha correttamente saldato il pagamento 2018 - &nbsp;
            <button className="btn btn-info" onClick={this.props.downloadReceipt}>Scarica Ricevuta</button>
          </div>
        )}
        {!payed && (
          <div>
            {!!this.state.showAdjustmentDetails && (
              <React.Fragment>
                <div className="row">
                  <div className="col-md-6">
                    <h3>Veicoli</h3>
                    <ul>
                      {vehicle1 && <li>{vehicle1}</li>}
                      {vehicle2 && <li>{vehicle2}</li>}
                      {vehicle3 && <li>{vehicle3}</li>}
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <h3>Contrassegni</h3>
                    <ul>
                      {mark1 && <li>{mark1}</li>}
                      {mark2 && <li>{mark2}</li>}
                      {mark3 && <li>{mark3}</li>}
                    </ul>
                  </div>
                </div>

                <div>
                  <h3>
                    Totale da pagare: €{' '}
                    {Number(total).toLocaleString('it-IT', {
                      minimumFractionDigits: 2, maximumFractionDigits: 2
                    })}
                  </h3>
                </div>
                <from>
                  <div className="radio">
                    <label>
                      <input
                        type="radio"
                        name="method"
                        value="SPORTELLO_POS"
                        onChange={() => this.setState({payment: 'SPORTELLO_POS'})}
                        checked={this.state.payment === 'SPORTELLO_POS'}
                        required
                      />
                      POS
                    </label>
                  </div>
                  <div className="radio">
                    <label>
                      <input
                        type="radio"
                        name="method"
                        value="SPORTELLO_CONTANTI"
                        onChange={() => this.setState({payment: 'SPORTELLO_CONTANTI'})}
                        checked={this.state.payment === 'SPORTELLO_CONTANTI'}
                        required
                      />
                      CONTANTI
                    </label>
                  </div>
                </from>
                <button
                  style={{marginRight: '1rem'}}
                  className="btn btn-info"
                  onClick={() => this.props.onPay(this.state.payment)}>Imposta come Pagato</button>
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    this.setState({ showAdjustmentDetails: false })
                  }
                >
                  Chiudi Dettagli
                </button>
              </React.Fragment>
            )}

            {!this.state.showAdjustmentDetails && (
              <React.Fragment>
                <span>
                  Questo Utente deve ancora saldare il pagamento 2018
                </span>
                <button
                  style={{marginLeft: '1rem'}}
                  className="btn btn-secondary"
                  onClick={() => this.setState({ showAdjustmentDetails: true })}
                >
                  Mostra Dettagli
                </button>
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Alert/BackOfficeAlert.js